import { render, staticRenderFns } from "./highlights-small.vue?vue&type=template&id=28d6c0d6&"
import script from "./highlights-small.vue?vue&type=script&lang=js&"
export * from "./highlights-small.vue?vue&type=script&lang=js&"
import style0 from "./highlights-small.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports